import { CONSTANTS } from '@shared/constants';

export const VENUE_CAMPAIGNS_ROUTES_PATHS_PARTIALS: { BASE_PATH: string } = {
  BASE_PATH: CONSTANTS.ROUTES.CAMPAIGNS,
};
